{
  // eslint-disable-line no-lone-blocks
  const doc = window.document
  // const docEl = doc.documentElement
  const docBody = doc.body
  const platform = window.navigator.userAgent.toLowerCase()
  if(/iPhone|iPad|iPod|iOS/i.test(platform)) {
    // console.log(doc, docEl)
    docBody.classList.add('ios_ignore')
    console.log('detect ios, adapt successfully!!!')
  } else {
    window.onresize = function (e) {
      e.preventDefault() // 阻止默认行为
      e.stopImmediatePropagation() // 阻止事件冒泡
      let dom = window.document.querySelector('#item_focused')
      if(dom) {
        setTimeout(() => {
          let offsetTop = window.document.querySelector('#item_focused')
            .offsetTop // 获取focus的元素到父元素的高度（scroll需要滑动的高度）
          window.document.querySelectorAll('.sections_ignore').forEach(item => {
            item.scrollTo(0, offsetTop) // scroll滑动
          })
        }, 0)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/autoAdapt.js